import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Organization } from 'utils';

type ReturnType = Promise<AxiosResponse<Organization>>;

export interface UpdateOrganizationPayload {
    name?: string;
    logo_path?: string;
    zip?: string;
    marketplace_enabled?: boolean;
    owner_first_name?: string | null;
    owner_last_name?: string | null;
    owner_email?: string | null;
    owner_phone?: string | null;
}

const updateOrganization = (uuid: string, payload: UpdateOrganizationPayload = {}): ReturnType => {
    return Request.put(`/organizations/${uuid}`, payload);
};

export default updateOrganization;
